import instance from './auth';

export const getAll = async (params) => (await instance.get('/partners', {params})).data;
export const getById = async (id) => (await instance.get(`/partners/${id}`)).data;
export const decide = async (id, status, review_notes = '') => (await instance.put(`/partners/${id}/decision`, {status, review_notes})).data;
